import React from 'react';
import '../../scss/parentArticles.scss';
import { FaArrowRight } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import ArticleCard from './ArticleCard';

// Mock data for parent articles
const PARENT_ARTICLES = [
  {
    id: 1,
    title: "Nutrition Tips for Young Athletes Before a Game",
    excerpt: "Simple meal ideas and nutrition advice to fuel your child's performance on match days and during training.",
    image: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?auto=format&fit=crop&w=600&h=400&q=80",
    slug: "nutrition-tips",
    category: "Nutrition",
    date: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    })
  }
];

const ParentArticles = () => {
  const navigate = useNavigate();
  
  const handleReadArticle = (slug) => {
    navigate(`/parent/article/${slug}`);
  };
  
  return (
    <div className="matches-container dashboard">
      <div className="matches-container-header container">
        <h2 className="section-title">
          Parent Resources
        </h2>
      </div>
      <div className="matches-scroll-container">
        <div className="matches-scroll-wrapper">
          {PARENT_ARTICLES.map(article => (
            <div className="article-card-wrapper" key={article.id}>
              <ArticleCard article={article} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ParentArticles; 